export default "__VITE_ASSET__BoaOmsEr__"